import * as angular from "angular";

export class CanvassService {
    private apiRoot: string;
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/canvass";
        this.v2Root = "/v2/canvass";
    }

    info(data: { id: string | number }): Promise<object> {
        return this.$http.get(this.apiRoot + "/info/" + data.id);
    }

    types(): Promise<object> {
        return this.$http.get(this.apiRoot + "/status");
    }

    user(params: { filter: object; offset: object }): Promise<object> {
        return this.$http.get(this.apiRoot + "/user", { params: params });
    }

    create(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/create", data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/update/" + data.csid, data);
    }

    delete(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.id);
    }
}

angular.module("vcServices").service("CanvassService", CanvassService);
